var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "landing" },
    [
      _c("el-row", [
        _c(
          "div",
          { staticClass: "landing-header-container" },
          [
            _c("Ticker", { attrs: { slides: _vm.slides } }),
            _vm._v(" "),
            _c("Header", { staticClass: "landing-header" }, [
              !_vm.isMobile()
                ? _c("div", { staticClass: "landing-header-left" }, [
                    _c("div", { staticClass: "landing-header-title" }, [
                      _vm._v(
                        "\n                        Chicago Athenaeum Museum of Architecture and Design\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "landing-header-title" }, [
                      _vm._v(
                        "\n                        European Centre for Architecture Art Design and\n                        Urban Studies\n                    "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "landing-header-middle" }, [
                _c("div", { staticClass: "landing-header-title" }, [
                  _vm._v("\n                        TCA - ECADUS "),
                  _c("br"),
                  _vm._v(
                    "\n                        AWARDS SUBMISSION PAGE\n                    "
                  ),
                ]),
              ]),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("Slider", { attrs: { slides: _vm.slides } }),
          _vm._v(" "),
          _c("div", { staticClass: "landing-tutorial" }, [
            _c("img", {
              staticClass: "arrow-image",
              attrs: { src: "/images/arrow.png" },
            }),
            _vm._v(" "),
            _c(
              "div",
              [
                _vm._v(
                  "\n                Welcome to The Chicago Athenaeum and The European Centre\n                Submission page. "
                ),
                _c("BR"),
                _vm._v(
                  "\n                Download the New Application Guide for Submission\n                Instructions\n                "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      target: "_blank",
                      href: "https://awardapplication.com/pdf/TCA-FORMS-INSRUCTIONS.pdf",
                    },
                  },
                  [_vm._v("here")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("Grid"),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-row", [
        _c("footer", [
          _c("section", { staticClass: "ft-main" }, [
            _c("div", { staticClass: "ft-main-item" }, [
              _c("div", { staticClass: "line" }),
              _vm._v(" "),
              _c("h2", { staticClass: "ft-title" }, [
                _vm._v("Awards Organizers"),
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.chi-athenaeum.org/",
                        target: "_blank",
                      },
                    },
                    [_vm._v("The Chicago Athenaeum")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://europeanarch.eu/",
                        target: "_blank",
                      },
                    },
                    [_vm._v("The European Centre")]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ft-main-item" }, [
              _c("div", { staticClass: "line" }),
              _vm._v(" "),
              _c("h2", { staticClass: "ft-title" }, [_vm._v("Legal")]),
              _vm._v(" "),
              _c("ul", [
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "terms-and-conditions",
                          },
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                Terms & Conditions\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "refund-policy",
                          },
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                Refund Policy\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ft-main-item" }, [
              _c("div", { staticClass: "line" }),
              _vm._v(" "),
              _c("h2", { staticClass: "ft-title" }, [_vm._v("Connect")]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.instagram.com/thechicagoathenaeummuseum/",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Instagram")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.facebook.com/TheChicagoAthenaeumMuseum?ref=hlm",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Facebook")]
                  ),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.youtube.com/@thechicagoathenaeummuseum",
                        target: "_blank",
                      },
                    },
                    [_vm._v("Youtube")]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ft-main-item" }, [
              _c("div", { staticClass: "line" }),
              _vm._v(" "),
              _c("h2", { staticClass: "ft-title" }, [_vm._v("Contact")]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c("a", { attrs: { href: "#" } }, [
                    _vm._v("curatorial@chi-athenaeum.org"),
                  ]),
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("a", { attrs: { href: "#" } }, [
                    _vm._v("tel: +1 815 777 4444 (extension 3000)"),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "ft-legal" }, [
            _vm._v(
              "\n                © 2024 - 2026 All rights reserved for The Chicago\n                Athenaeum Museum of Architecture and Design , European\n                centre for Architecture Art Design and Urban Studies,\n                Metropolitan Arts Press Ltd.\n            "
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }